import { BodyMedium, SearchIcon, theme } from '@arnold/common';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

export const EmptySearchResult = () => {
  const { t } = useTranslation('newReport');

  return (
    <Container>
      <IconWrapper>
        <SearchIcon />
      </IconWrapper>
      <BodyMedium color={theme.colors.text.secondary}>{t('noSearchResults')}</BodyMedium>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spacing.j} ${theme.spacing.g};
  gap: ${theme.spacing.f};
`;

const IconWrapper = styled.div`
  svg {
    width: 40px;
    height: 40px;
    color: ${theme.colors.iconText.disabled};
  }
`;
